export default __webpack_public_path__ + "static/media/028-waiting.df5761f4.png";